import { render, staticRenderFns } from "./SectionAbout.vue?vue&type=template&id=6dd418eb&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"
import style0 from "./SectionAbout.vue?vue&type=style&index=0&id=6dd418eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd418eb",
  null
  
)

export default component.exports